import script from "./UserPolicyUpdate.vue?vue&type=script&setup=true&lang=js"
export * from "./UserPolicyUpdate.vue?vue&type=script&setup=true&lang=js"

import "./UserPolicyUpdate.vue?vue&type=style&index=0&id=b854b0bc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b854b0bc"]])

export default __exports__